<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Search Form
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="px-2 pt-4 pb-0">
                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="From Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="from_date.value.value"
                        :error-messages="from_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="To Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="to_date.value.value"
                        :error-messages="to_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-btn
                        class="bg-brand w-15"
                        type="submit"
                        ref="searchButton"
                        >Search</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid style="margin-top: -20px;">
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel1">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                LC Master Records
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="4" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          >CSV</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="4" cols="12">
                    <div class="text-right">
                      <v-btn
                        v-if="$insertAccess($route.fullPath)"
                        @click="goTo('/lc/export-lc-create')"
                        color="primary"
                        variant="tonal"
                        prepend-icon="mdi mdi-plus"
                        rounded="xl"
                      >
                        Create LC
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>

                <v-data-table
                  :headers="headers"
                  :items="getLcExportLcMasterList"
                  :search="search"
                  :loading="loading"
                  item-value="id"
                  class="elevation-1"
                  density="compact"
                >
                  <template v-slot:item.index="{ index }">
                    {{ index + 1 }}
                  </template>

                  <template v-slot:item.lc_no="{ item }">
                    {{ item.lc_no }}
                  </template>

                  <template v-slot:item.code="{ item }">
                    {{ item.code }}
                  </template>

                  <template v-slot:item.lc_open_date="{ item }">
                    {{ formatDate(item.lc_open_date) }}
                  </template>

                  <template v-slot:item.expiry_date="{ item }">
                    {{ formatDate(item.expiry_date) }}
                  </template>

                  <template v-slot:item.supplier="{ item }">
                    {{ item.supplier?.supplier_name || "N/A" }}
                  </template>

                  <template v-slot:item.lcType="{ item }">
                    <span v-if="item.lcType && item.lcType.name">
                      {{ item.lcType.name }}
                    </span>
                    <span v-else-if="item.lc_type && item.lc_type.name">
                      {{ item.lc_type.name }}
                    </span>
                    <span v-else-if="item.lcType && item.lcType.code">
                      {{ item.lcType.code }}
                    </span>
                    <span v-else>
                      N/A
                    </span>
                  </template>

                  <template v-slot:item.lc_amount="{ item }">
                    {{ $numberFormat(item.lc_amount) }}
                  </template>

                  <template v-slot:item.lc_status="{ item }">
                    <v-chip
                      :color="getLcStatusColor(item.lc_status)"
                      size="small"
                      variant="tonal"
                    >
                      {{ item.lc_status || "Open" }}
                    </v-chip>
                  </template>

                  <template v-slot:item.approval_status="{ item }">
                    <v-chip
                      :color="getApprovalStatusColor(item.approval_status)"
                      size="small"
                      variant="tonal"
                    >
                      {{ item.approval_status || "Approved" }}
                    </v-chip>
                  </template>

                  <template v-slot:item.status="{ item }">
                    <v-chip
                      :color="item.status == 1 ? 'success' : 'warning'"
                      size="small"
                    >
                      {{ item.status == 1 ? "Posted" : "Draft" }}
                    </v-chip>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      icon="mdi-pencil"
                      size="small"
                      variant="text"
                      color="primary"
                      @click="editItem(item.id)"
                    ></v-btn>
                    <v-btn
                      icon="mdi-eye"
                      size="small"
                      variant="text"
                      color="info"
                      @click="viewItem(item.id)"
                    ></v-btn>
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import formattedDate from "@/plugins/dateFormatter";
import { formatDateView, formatDateDash } from "@/plugins/helpers";
import { useField, useForm } from "vee-validate";
import { getCurrentInstance, ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import { toast } from "vue3-toastify";
import { useStore } from "vuex";

export default {
  data: () => ({
    panel: [0],
    panel1: [0],
    loading: false,
    search: "",
    headers: [
      { title: "#SL", align: "center", key: "index", width: "5%", sortable: false },
      { title: "LC No", key: "lc_no", align: "left", sortable: true },
      { title: "LC Code", key: "code", align: "left", sortable: true },
      { title: "Open Date", key: "lc_open_date", align: "left", sortable: true },
      { title: "Expiry Date", key: "expiry_date", align: "left", sortable: true },
      { title: "Supplier", key: "supplier", align: "left", sortable: false },
      { title: "LC Type", key: "lcType", align: "left", sortable: false },
      { title: "LC Amount", key: "lc_amount", align: "right", sortable: true },
      { title: "LC Status", align: "center", key: "lc_status", sortable: true },
      { title: "Approval Status", align: "center", key: "approval_status", sortable: true },
      { title: "Status", align: "center", key: "status", sortable: true },
      { title: "Actions", align: "center", key: "actions", sortable: false, width: "10%" },
    ],
  }),
  setup() {
    const { handleSubmit } = useForm();
    const from_date = useField("from_date");
    const to_date = useField("to_date");
    const store = useStore();
    const router = useRouter();

    const getLcExportLcMasterList = computed(() => {
      return store.getters.getLcExportLcMasterList || [];
    });

    onMounted(() => {
      loadData();
    });

    const loadData = async () => {
      try {
        await store.dispatch("getLcExportLcMasterList");
      } catch (error) {
        toast.error(error.response?.data?.message || "Failed to load LC Master records");
      }
    };

    const submit = handleSubmit(async (values) => {
      // Filter/search logic can be added here if needed
      await loadData();
    });

    const formatDate = (date) => {
      if (!date) return "";
      return formatDateView(date);
    };

    const getLcStatusColor = (status) => {
      const colors = {
        Draft: "grey",
        Open: "info",
        Amended: "warning",
        Shipped: "primary",
        "Document-Received": "blue",
        Cleared: "success",
        Closed: "default",
        Cancelled: "error",
      };
      return colors[status] || "grey";
    };

    const getApprovalStatusColor = (status) => {
      const colors = {
        Pending: "warning",
        Approved: "success",
        Cancelled: "error",
      };
      return colors[status] || "success";
    };

    const editItem = (id) => {
      router.push({ path: `/lc/export-lc-create/${id}` });
    };

    const viewItem = (id) => {
      router.push({ path: `/lc/export-lc-view/${id}` });
    };

    const goTo = (val) => {
      router.push({ path: val }).catch((err) => {});
    };

    const exportToCSV = () => {
      toast.info("CSV export feature coming soon");
    };

    const exportToExcel = () => {
      toast.info("Excel export feature coming soon");
    };

    const exportToPDF = () => {
      toast.info("PDF export feature coming soon");
    };

    return {
      from_date,
      to_date,
      getLcExportLcMasterList,
      submit,
      editItem,
      viewItem,
      exportToCSV,
      exportToExcel,
      exportToPDF,
      loadData,
      formatDate,
      getLcStatusColor,
      getApprovalStatusColor,
      goTo,
    };
  },
  methods: {
    formatDate(date) {
      if (!date) return "";
      return formatDateView(date);
    },
  },
};
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}
</style>

